/* eslint-disable no-console */

import { register } from 'register-service-worker'

// Déplacer tout le code d'initialisation du service worker à l'intérieur de l'événement DOMContentLoaded
document.addEventListener('DOMContentLoaded', () => {
    // Récupérer vueAppBaseUrl de l'élément app une fois que le DOM est chargé
    var appElement = document.getElementById('app');
    var vueAppBaseUrl = appElement ? appElement.getAttribute('vueappbaseurl') : null;
    vueAppBaseUrl = vueAppBaseUrl || process.env.VUE_APP_BASE_URL;
    var vueAppBaseUrlBIS = vueAppBaseUrl.replace(/\/$/, ''); // Supprime le slash final s'il existe

    var path =
        process.env.VUE_APP_STANDALONE == 'true'
            ? ''
            : 'wp-content/plugins/bouge-io/content/dist';

    if (process.env.NODE_ENV === 'production') {
        // Ne tente d'enregistrer le service worker que si vueAppBaseUrl est défini
        if (vueAppBaseUrlBIS) {
            register(`${vueAppBaseUrlBIS}/${path}/firebase-messaging-sw.js`, {
                ready() {
                    console.log(
                        'App is being served from cache by a service worker.\n' +
                            'For more details, visit https://goo.gl/AFskqB'
                    )
                },
                registered() {
                    console.log('Service worker has been registered.')
                },
                cached() {
                    console.log('Content has been cached for offline use.')
                },
                updatefound() {
                    console.log('New content is downloading.')
                },
                updated() {
                    console.log('New content is available; please refresh.')
                },
                offline() {
                    console.log(
                        'No internet connection found. App is running in offline mode.'
                    )
                },
                error(error) {
                    console.error('Error during service worker registration:', error)
                }
            });

            //LTU 2025 register(`${vueAppBaseUrlBIS}/firebase-messaging-sw.js`);
        } else {
            console.warn('Service worker registration skipped: vueAppBaseUrl is not defined');
        }
    }
});
